import { StyleSheet } from 'react-native';
import { DBK16_FONT_FAMILY } from '../../../../assets/styles/styles-dbk16/constants';

export default StyleSheet.create({
  container: {
    minHeight: 64,
    flexDirection: 'row',
    alignItems: 'center',
    // backgroundColor: '#0e1b34',
    opacity: 0.7,
    marginTop: 2,
    borderRadius: 2,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  text: {
     fontFamily: DBK16_FONT_FAMILY.DB_REGULAR,
  },
  rowRight: {
    marginLeft: 5,
    marginRight: 5,
    width: 20,
  },
  portfolioText: {
    marginLeft: 5,
    marginRight: 5,
    minWidth: 110,
  },
  pfText:{
    marginRight: 60,
    fontFamily: DBK16_FONT_FAMILY.DB_REGULAR,
  }
});
